import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import AboutUsContent from './AboutUsContent';

function AboutUs({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <AboutUsContent page={page} />
    </PageWrapper>
  );
}

AboutUs.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'about_us',
})(AboutUs);



// WEBPACK FOOTER //
// ./src/pages/AboutUs/index.js